import { Component, ViewContainerRef, ViewChild, Renderer2, ChangeDetectorRef, Inject, Type, Optional } from '@angular/core';
import { opacity } from '../../../../common/animations/animations';
import { Subscription, Subject } from 'rxjs';
import { ToolBarService, DATA_TABLE_TOOLBAR_DATA } from './tool-bar.service';

@Component({
    selector: 'data-table-tool-bar',
    templateUrl: './tool-bar.component.html',
    styleUrls: ['./tool-bar.component.scss'],
    animations: [opacity('50ms')],
    standalone: false
})
export class ToolBarComponent {
    @ViewChild("portal", { read: ViewContainerRef, static: true })
    public portal: ViewContainerRef;

    public showing: boolean = false;
    public subscriptions: Subscription = new Subscription();
    public _onClose: Subject<void> = new Subject();
    public _onOpen: Subject<void> = new Subject();

    get onClose() {
        return this._onClose.asObservable();
    }

    get onOpen() {
        return this._onOpen.asObservable();
    }


    constructor(
		public _toolBarService: ToolBarService,
		public _renderer: Renderer2,
		public _changeDetectorRef: ChangeDetectorRef,
		@Optional() @Inject(DATA_TABLE_TOOLBAR_DATA) public data: { component: Type<any>, data: any }[]
    ) { }

    ngAfterViewInit() {
        let el = this._toolBarService.grid['_nativeElement'];
        this.subscriptions.add(this._renderer.listen(el, 'mouseenter', () => {
            this._onOpen.next();
            this.showing = true;
            this._changeDetectorRef.detectChanges();
        }));

        this.subscriptions.add(this._renderer.listen(el, 'mouseleave', () => {
            this._onClose.next();
            this.showing = false;
            this._changeDetectorRef.detectChanges();
        }));

		if (this.data && this.portal) {
			this._toolBarService.addToolbars(this.data, this.portal);
		}
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
